'use strict';
var isObject = require('../internals/is-object');

module.exports = function (argument) {
  return isObject(argument) || argument === null;
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/is-possible-prototype.js
// module id = 985
// module chunks = 0